module.exports = __webpack_public_path__ + "img/filter.914012c0.svg";